module.exports = __webpack_public_path__ + "img/talks_3.255fd143.png";